<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load(1)" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-calendar fa-fw"
                            type="select"
                            placeholder="Data do Fechamento"
                            :optionsList="[
                                { id: 'R', search: 'Data do Registro' }
                            ]"
                            optionsData="id"
                            v-model="filtro.tipo_data" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas as Unidades..."
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtro.id_unidade_operacao" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Todos os Tipos..."
                            type="select" 
                            optionsMode="json"
                            :optionsList="[
                                { id: 'geral', search: 'Geral' },
                                { id: 'atendimento', search: 'Recepção' },
                                { id: 'lancamento', search: 'Lançamentos' },
                                { id: 'baixa', search: 'Baixas' },
                                { id: 'estoqueMovimentacao', search: 'Movimentações de Suprimentos' },
                            ]"
                            optionsData="id"
                            icon="fas fa-lock fa-fw" 
                            v-model="filtro.tipo" />
                    </div>
                    <!-- Especiais -->
                    <div class="col col-12 col-md-3" v-if="filtro.tipo == 'baixa'">
                        <az-input
                            placeholder="Todas as Contas..."
                            icon="fas fa-money-check-alt fa-fw"
                            type="select"
                            optionsName="contas-ativas"
                            optionsMode="aql"
                            service="contas.index"
                            optionsData="id_conta"
                            optionsDisplay="search"
                            :optionsParm="{ ativas: true }"
                            v-model="filtro.id_conta" />
                    </div>
                    <div class="col col-12 col-md-3" v-else>
                        <az-input
                            placeholder="..."
                            icon="fas fa-slash fa-fw"
                            :edicao="false" />
                    </div>
                    <!-- Fim Especiais -->
                    <div class="col col-12 col-md-6">
                        <az-input icon="fa fa-search fa-fw" v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="incluir()">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2" v-if="lista && lista.length">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>    

        
        <az-empty-state 
            class="mt-3" 
            v-if="!lista || !lista.length" 
            msg="Nenhum fechamento registrado." 
            icon="fas fa-lock" />

        <!-- Lista de items -->
        <template v-else>

            <div id="lista-fechamentos">
                
                <template>

                    <div class="mb-3 mx-3">
                        <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity" :class="item.fl_ativo ? 'bg-white' : ''" v-for="(item, index) in lista" :key="index">
                            <!-- Ação -->
                            <div class="col col-12 col-md-2">
                                <div class2="d-flex flex-column">
                                    <div class="text-nowrap text-truncate">
                                        <div>
                                            <i class="far fa-calendar-plus fa-fw mr-2"></i>
                                            {{ $util.getFormatDate(item.created_at.substr(0,10)) }}
                                        </div>
                                        <div>
                                            <i class="fas fa-lock fa-fw mr-2"></i>
                                            {{ $util.getFormatDate(item.dt_fechamento) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Data -->
                            <div class="col col-12 col-md-3"> 
                                <div>
                                    #{{ item.id_fechamento }}
                                    <span class="badge badge-danger ml-2" v-if="!item.fl_ativo">Removido</span>
                                </div>
                                <div>{{ item.search }}</div>
                            </div>
                            <!-- Identificação do Paciente -->
                            <div class="col col-12 col-md-3">
                                <i class="fa fa-building-o fa-fw mr-2" aria-hidden="true"></i>
                                <span v-if="item.id_unidade_operacao">
                                    {{ item.unidade.search }}
                                </span>
                                <span v-else>
                                    Todas
                                </span>

                                <div v-if="item.conta">
                                    <i class="fa-solid fa-circle-dollar-to-slot fa-fw mr-2"></i>
                                    {{ item.conta.search }}
                                </div>
                            </div>

                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                <div class="small">{{ item.st_obs }}</div>

                                <!-- Menu de opções -->
                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item" @click="remover(item)" :disabled="!item.fl_ativo">
                                            <i class="fa fa-times fa-fw mr-2" aria-hidden="true"></i>
                                            Remover
                                        </button>

                                        <button class="dropdown-item" @click="$util.logAudit('fechamento', item.id_fechamento)">
                                            <i class="fa fa-file-o fa-fw mr-2" aria-hidden="true"></i>
                                            Log
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

        </template>

        <br><br><br><br><br>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <!-- Modal Fechamento -->
        <div class="modal fade" id="fechamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span v-if="!edicao.id_fechamento">Novo</span>
                            Fechamento
                            <span v-if="edicao.id_fechamento" class="badge badge-secondary ml-3">
                                #{{ edicao.id_fechamento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Tipo"
                                    placeholder="Selecione..."
                                    type="select" 
                                    optionsMode="json"
                                    :optionsList="tipos"
                                    optionsData="id"
                                    required
                                    :validate="validate"
                                    v-model="edicao.st_tipo" />
                            </div>
                            <!-- Especial -->
                            <div class="col col-12 col-md-6" v-if="edicao.st_tipo == 'baixa'">
                                <az-input
                                    label="Conta"
                                    placeholder="Todas as Contas..."
                                    type="select"
                                    optionsName="contas-ativas"
                                    optionsMode="aql"
                                    service="contas.index"
                                    optionsData="id_conta"
                                    optionsDisplay="search"
                                    :optionsParm="{ ativas: true }"
                                    v-model="edicao.id_conta" />
                            </div>
                            <!-- Fim Especial -->
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Data do Fechamento"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="edicao.dt_fechamento" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    placeholder="Todas"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    v-model="edicao.id_unidade_operacao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    type="textarea"
                                    rows="3"
                                    v-model="edicao.st_obs" />
                            </div>
                        </div>

                        <pre v-if="false">{{ edicao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">
                            {{ edicao.id_fechamento ? 'Atualizar' : 'Incluir' }}
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return {
            dados: null, 
            from: this.$util.hoje(),
            to: this.$util.hoje(),
            filtro: { 
                id_unidade_operacao: "", 
                tipo: "", 
                inicio: "",
                fim: "",
                periodo: "m",
                semana: "",
                mes: "", 
                id_conta: "", 
                tipo_data: "", 
            },
            filas: [], 
            search: "",
            laudo: null, 
            lista_status: [], 
            novo_contato: null, 
            edicao: null, 
            validate: false, 
            canceltoken: null, 
            page: 1, 
            contadores: [], 
            acao_anexar: true, 
            edicao_guia: null,
            espelho: null, 
            tipos: [
                { id: 'geral', search: 'Geral' },
                { id: 'atendimento', search: 'Recepção' },
                { id: 'lancamento', search: 'Lançamentos' },
                { id: 'baixa', search: 'Baixas' },
                { id: 'estoqueMovimentacao', search: 'Movimentações de Suprimentos' },
            ],
        }
    },
    components: { 
        AzInput,
        AzEmptyState, 
        AzPeriodo, 
        AzSubmit,  
    },

    watch: { 
        filtro: { 
            handler: function () {
                if ( !this.filtro.id_fila_lead ) 
                    return;

                // this.load ();
            },
            deep: true,
            immediate: true
        }
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            return this.dados.data.filter(item => ( !this.search || reg.test(JSON.stringify(item)) ));
        },
    },

    methods: { 
        remover(item) { 
            this.$util.remover(this, { 
                service: 'fechamentos',
                dados: { 
                    id_fechamento: item.id_fechamento, 
                },
                toast: true, 
            });
        },

        incluir() { 
            this.validate = false;

            this.edicao = { 
                id_unidade_operacao: "", 
                st_tipo: "", 
                dt_fechamento: "", 
                st_obs: "", 
                id_conta: "",
                id_estoque_local: "", 
            };

            $('#fechamentoModal').modal('show');
        },

        paginar (page) {
            this.page = page;
            this.load();
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: "fechamentos",
                dados: this.edicao,
                modal: "fechamentoModal",
                toast: true, 
                reload: true 
            });
        },

        load(page = null) { 
            if ( page )
                this.page = page;

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.$util.load(this, { 
                service: 'fechamentos',
                func: 'index',
                canceltoken: this.canceltoken.token,
                parms: { 
                    ...this.filtro, 
                    page: this.page,
                    size: 100, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    },

    mounted() { 

        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro/lancamento" },
            { name: "Fechamento", path: "/financeiro/fechamentos" }
        ]);

        this.load();

    }
    
}
</script>

